import CloudRenderManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'cloud-render-management',
  title: '云渲染设置',
  version: '0.1.50',
  description: '云渲染设置',
  routes: CloudRenderManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['CloudRenderManagementAPI', 'DataCategoryApi', 'ModelSceneApi'],
  },
}
